import { FunctionalComponent, h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'

const pages = {
  slack: 'https://help.fathom.video/en/articles/448576',
  salesforce: 'https://help.fathom.video/en/articles/448640',
}

export type PageName = keyof typeof pages

export const MoreInfo: FunctionalComponent<JSXBase.IntrinsicElements['a'] & { maxTooltipWidth?: string }> = (
  { class: className = '', maxTooltipWidth, ...attrs },
  children
) => {
  const Tag = attrs.href ? 'a' : 'span'
  return (
    <Tag class={`inline-block leading-none align-baseline group ${className}`} {...attrs}>
      <ui-icon icon='question-circle' class='group-hover:hidden' />
      <ui-icon icon='question-circle-fill' class='hidden group-hover:block' />
      <ui-tooltip>
        <div class='text-center' style={{ maxWidth: maxTooltipWidth ?? '200px' }}>
          {children}
        </div>
      </ui-tooltip>
    </Tag>
  )
}

export function LearnMore<T extends PageName>({ page }: { page: T }) {
  return (
    <MoreInfo href={pages[page]} target='_blank'>
      Click to Learn More
    </MoreInfo>
  )
}
